/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationListingsPositionSimulation_PositionOnListing } from '../models/AccommodationListingsPositionSimulation_PositionOnListing';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationListingsPositionSimulationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Calculates the position on the listing for given accommodation.
     * Retrieves a AccommodationListingsPositionSimulation resource.
     * @param commission Accommodation's commission percent: 0.0 - 1.0
     * @param id AccommodationListingsPositionSimulation identifier
     * @param listingType AccommodationListingsPositionSimulation identifier
     * @param listingId AccommodationListingsPositionSimulation identifier
     * @returns AccommodationListingsPositionSimulation_PositionOnListing AccommodationListingsPositionSimulation resource
     * @throws ApiError
     */
    public accommodationListingPositionSimulator(
        commission: number,
        id: string,
        listingType: string,
        listingId: string,
    ): CancelablePromise<AccommodationListingsPositionSimulation_PositionOnListing> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/{id}/listings/{listingType}/{listingId}/position-simulation',
            path: {
                id: id,
                listingType: listingType,
                listingId: listingId,
            },
            query: {
                commission: commission,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
